var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 94,
    viewBox: "0 0 101 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2 37.6V12.5333L50.1333 0L25.0667 12.5333V37.6L0 50.1333V81.4667L25.0667 94L50.1333 81.4667L75.2 94L100.267 81.4667V50.1333L75.2 37.6ZM50.6973 7.01867L68.9333 16.0427L52.64 24.1893L34.404 15.1653L50.6973 7.01867ZM31.3333 17.4213L50.1333 26.8213V49.3813L31.3333 39.9813V17.4213ZM25.0667 86.9813L6.26667 77.5813V55.0213L25.0667 64.4213V86.9813ZM26.8213 61.9147L8.77333 52.7653L25.0667 44.6187L43.1147 53.6427L26.8213 61.9147ZM75.2 86.9813L56.4 77.5813V55.0213L75.2 64.4213V86.9813ZM76.9547 61.9147L58.9067 52.7653L75.2 44.6187L93.248 53.6427L76.9547 61.9147Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.d69d74a4e5555ebb2428ec73287f2ebb.svg";
export { ForwardRef as ReactComponent };